import React from 'react';
import TitlePage from '../../components/general/TitlePage/TitlePage';
import CardToolList from '../../components/extern/CardTool/utils/CardToolList';

const ToolPage = () => {
  return (
    <main>
      <TitlePage
        title="Explore Ferramentas"
        subtitle="Utilize recursos poderosos para otimizar suas campanhas, sejam internas ou externas."
      />
      <CardToolList />
    </main>
  );
};

export default ToolPage;
